import { Actor, Color, Entity, Scene } from 'excalibur';
import { SKINS, Theme } from './skins';

export type { Theme, ThemePalette } from './skins';

const SKIN_STORAGE_KEY = 'crazy-clock-skin';

let activeTheme: Theme = SKINS[0];

function readStoredTheme(): Theme {
  try {
    const stored = window.localStorage.getItem(SKIN_STORAGE_KEY);
    const match = SKINS.find((skin) => skin.id === stored);
    if (match) {
      return match;
    }
  } catch {
    return SKINS[0];
  }
  return SKINS[0];
}

activeTheme = readStoredTheme();

export function getTheme(): Theme {
  return activeTheme;
}

export type ThemePaletteKey = keyof Theme['palette'];

export function activeThemeId(): string {
  return activeTheme.id;
}

type ThemeListener = () => void;

const themeListeners: ThemeListener[] = [];

export function onThemeChanged(listener: ThemeListener): void {
  themeListeners.push(listener);
}

export function setTheme(id: string): Theme {
  const match = SKINS.find((skin) => skin.id === id);
  if (!match) {
    return activeTheme;
  }
  activeTheme = match;
  try {
    window.localStorage.setItem(SKIN_STORAGE_KEY, match.id);
  } catch {
    return activeTheme;
  }
  for (const listener of themeListeners) {
    listener();
  }
  return activeTheme;
}

export function getDoodleColors(): Color[] {
  return activeTheme.doodleColors;
}

export interface ThemeAware {
  refreshTheme(): void;
}

function refreshActor(actor: Actor): void {
  const themed = actor as unknown as { refreshTheme?: () => void; children?: readonly Entity[] };
  if (typeof themed.refreshTheme === 'function') {
    themed.refreshTheme();
  }
  for (const child of themed.children ?? []) {
    if (child instanceof Actor) {
      refreshActor(child);
    }
  }
}

export function refreshSceneTheme(scene: Scene): void {
  for (const actor of scene.actors) {
    refreshActor(actor);
  }
}
